const getAugmentedPhoneNumbers = function (state, getters) {
  const possibleTollFree = ['tollFree', 'tollfree', 'toll free', 'Toll Free', 'Tollfree']

  function checkIfTollFree(phoneNumber: string) {
    return possibleTollFree?.includes(
      state.locationTwilio.numberMeta[phoneNumber]?.numberType
    )
  }

  function evaluateTollFreeStatus(phoneNumber: string, sid: string) {
    const { status } = getters.getTollFreeData(sid, phoneNumber)
    return checkIfTollFree(phoneNumber) ? status : null
  }

  return function (collection: any[]) {
    const result = collection?.map(item => {
      const phoneNumber = item?.phoneNumber ?? item?.phone_number
      const sid = item?.sid

      item.client = {
        inHighLevelDB: Boolean(state.locationTwilio?.numbers[phoneNumber]),
        isDefaultOutboundNumber: Boolean(
          state.locationTwilio?.defaultOutboundNumber === phoneNumber
        ),
        isA2PVerified: Boolean(state.phoneNumbersA2PLookup[sid]),
        isTollFree: checkIfTollFree(phoneNumber),
        tollFreeStatus: evaluateTollFreeStatus(phoneNumber, sid),
        numberMeta:
          state.locationTwilio?.numberMeta[phoneNumber]
      }

      return item
    })

    return result
  }
}

export default getAugmentedPhoneNumbers
